import { Component, OnInit, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { cVoucher } from 'src/types/voucher';
import { cVoucherDiscountvalidate } from 'src/types/discountvailidate';
import { MessageService } from 'primeng/api';
import { HttpClient } from '@angular/common/http';
import { bmxurl, getAccess } from 'src/globals';
import { users_returndata } from 'src/types/user_returndata';
import { Payment } from 'src/PackageClasses';
import { paymenttypes_returndata } from 'src/types/paymenttypes_returndata';
import { BusyService } from '../_services/busy.service';
import { GlobalService } from '../_services/global.service';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { AuthService } from '@auth0/auth0-angular';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-buyvoucher',
  templateUrl: './buyvoucher.component.html',
  styleUrls: ['./buyvoucher.component.css']
})
export class BuyvoucherComponent implements OnInit{
  customAmountValue: number = 0;
  toggle5: boolean = false;
  toggle10: boolean = false;
  toggle20: boolean = false;
  toggle25: boolean = false;
  toggle50: boolean = false;
  toggle100: boolean = false;

  stateOptions: any[];
  NameValid: boolean = true;
  EmailValid: boolean = true;
  EmailFormatValid: boolean = true;

  RecipientNameValid: boolean = true;
  RecipientEmailValid: boolean = true;
  RecipientEmailFormatValid: boolean = true;

  ValueValid: boolean = true;

  messageValid: boolean = true;
  Voucher: cVoucher;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  httpResponse: any;
  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  pageReady: boolean = true;
  id: string;
  VoucherPayments: Payment[] = [];
  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;
  CurrencyMarker: string = "£";

  paymentValueValid: boolean = true;
  paymentValueExceededValid: boolean = true;
  paymentDepositValid: boolean = true;
  PaymentTypes: any[] = [];

  VoucherComplete: boolean = false;
  VoucherCreated: boolean = false;

  VouchersNotAvailable: boolean = false;
  showDeferReason:boolean = false;
  deferNotes: string = "";

  showDiscount: boolean = false;
  discountCode: string = "";

  terminalHubConnection: HubConnection | null = null;
  awaitingTerminalPayment: boolean = false;
  showPaymentFailedDialog: boolean = false;
  paymentFailedMessage: string = '';
  paymentButtonLocked: boolean = false;
  showTerminalBusyDialog: boolean = false;
  private pendingPaymentId: string = '';
  private pendingPaymentName: string = '';
  private pendingTerminalPayload: any = null;
  private pendingTerminalRetry: (() => void) | null = null;
  private terminalPaymentResolved: boolean = false;
  private terminalPollingIntervalId: ReturnType<typeof setInterval> | null = null;

  constructor(private route: ActivatedRoute, private http: HttpClient, private router: Router, private messageService: MessageService, private busyService: BusyService, private globalService: GlobalService, private auth: AuthService, private ngZone: NgZone) {
    this.stateOptions = [{ label: 'No', value: false }, { label: 'Yes', value: true }];
    this.Voucher = {
      id: null,
      venueid: this.VenueID,
      voucherid: null,
      vouchercode: "",
      voucherpin: 0,
      emailaddress: "",
      customername: "",
      alternativerecipient: false,
      recipientsname: "",
      recipientsemailsaddress: "",
      message: "",
      disabled: false,
      created: new Date(),
      expiry: new Date(),
      voucherexpiry: 0,
      initialvalue: 0,
      customamount: false,
      balance: 0,
      value: 0,
      payments: [],
      ischild: false,
      bookingid: "",
      bookingidhr: "",
      currency: this.CurrencySymbol,
      deferredpayment:false,
      defernotes: "",
      discounts: [],
      total: 0,
      totaldiscounts: 0
    }

    if(this.CurrencySymbol == "USD")
      this.CurrencyMarker = "$";
    else if(this.CurrencySymbol == "GBP")
      this.CurrencyMarker = "£";
    else if(this.CurrencySymbol == "EUR")
      this.CurrencyMarker = "€";
    //AUD fell through to the default below, which is why an Australian venue saw £5, £10 etc.
    //on the preset voucher buttons instead of its own currency.
    else if(this.CurrencySymbol == "AUD")
      this.CurrencyMarker = "$";
    else
    {
      this.CurrencyMarker = "£";
    }
  }

  returnHome()
  {
    this.Voucher = {
      id: null,
      voucherid: null,
      venueid: this.VenueID,
      vouchercode: "",
      voucherpin: 0,
      emailaddress: "",
      customername: "",
      alternativerecipient: false,
      recipientsname: "",
      recipientsemailsaddress: "",
      message: "",
      disabled: false,
      created: new Date(),
      expiry: new Date(),
      voucherexpiry: 0,
      initialvalue: 0,
      customamount: false,
      balance: 0,
      value: 0,
      payments: [],
      ischild: false,
      bookingid: "",
      bookingidhr: "",
      currency: this.CurrencySymbol,
      deferredpayment: false,
      defernotes: "",
      discounts: [],
      total: 0,
      totaldiscounts: 0
    }

    this.VoucherComplete = false
    this.VoucherCreated = false;

    this.showDiscount = false;
    this.discountCode = "";
    this.customAmountValue = 0;

    this.toggle5 = false;
    this.toggle10 = false;
    this.toggle20 = false;
    this.toggle25 = false;
    this.toggle50 = false;
    this.toggle100 = false;
  }

  printConfirmation(){
      window.print();
  }

  sendEmailConfirmation(){
    this.http.get<any>(bmxurl + "sendvoucher/" + this.VenueID + "/" + this.Voucher.voucherid).subscribe(response => {
      if(response.succeeded)
      {
        this.messageService.add({severity:'success', summary:'Success', detail:'Email Message sent.'})
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Failure', detail: response.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail: 'An error occurred whilst trying to send the Email'});
    })
  }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    this.busyService.busy();

    this.http.get(bmxurl + "paymenttypes").subscribe(response => {
      if((response as paymenttypes_returndata).succeeded)
      {
        this.PaymentTypes = (response as paymenttypes_returndata).data;
        this.PaymentTypes = this.PaymentTypes.filter(pt => pt.system == false);

        this.http.get(bmxurl + "User/" + userid).subscribe(response => {
          this.httpResponse =  (response as users_returndata)
          if(this.httpResponse.succeeded)
          {
            let user = this.httpResponse.data;
    
            if(getAccess("VOUCHERS", user)){
              this.AccessAllowed = true;
            }
          }
          this.CompletedLoading = true;
          this.busyService.idle();
        });
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Payment Types.'});
        this.CompletedLoading = true;
        this.busyService.idle()
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Failure', detail:'Failed to get Payment Types.'});
      this.CompletedLoading = true;
      this.busyService.idle()
    })
    
    let userid = localStorage.getItem("SmartUserID");

    //       this.id = this.route.snapshot.paramMap.get('id');
    //       if(this.id != "0")
    //       {
    //         this.pageReady = false;
    //         this.http.get(bmxurl + "Voucher/" + this.VenueID + "/" + this.id).subscribe(response => {
    //           this.httpResponse = (response as voucher_returndata)
    //           if (this.httpResponse.succeeded)
    //           {
    //             this.Voucher = {
    //               id: (this.httpResponse.data as cVoucher).id,
    //               venueId: this.VenueID,
    //               vouchercode: (this.httpResponse.data as cVoucher).vouchercode,
    //               emailaddress: (this.httpResponse.data as cVoucher).emailaddress,
    //               customername: (this.httpResponse.data as cVoucher).customername,
    //               recipientsname: (this.httpResponse.data as cVoucher).recipientsname,
    //               recipientsemailsaddress: (this.httpResponse.data as cVoucher).recipientsemailsaddress,
    //               message: (this.httpResponse.data as cVoucher).message,
    //               disabled: (this.httpResponse.data as cVoucher).disabled,
    //               created: (this.httpResponse.data as cVoucher).created,
    //               expiry: (this.httpResponse.data as cVoucher).expiry,
    //               initialvalue: (this.httpResponse.data as cVoucher).initialvalue,
    //               customamount: (this.httpResponse.data as cVoucher).customamount,
    //               balance: (this.httpResponse.data as cVoucher).balance,
    //             };
      
    //             this.pageReady = true;
    //           }
    //           else
    //           {
    //             this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting voucher'});
    //             this.pageReady = false;
    //           }
    //         }, error => {
    //           this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting voucher, error:' + error.messages[0]});
    //           this.pageReady = false;
    //         });
    //       }
    //     }

    //     this.CompletedLoading = true;

    //   }
    // }, error => {
    //   this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    // });

  }

  updateData(id, name)
  {
    if (this.DoValidCheck())
    {
      let newPayment: Payment = {
        id: null,
        PaymentId: null,
        BookingId: null,
        bookingIdHR: null,
        method: name,
        paymenttypeid: id,
        amount: this.PayableTotal,
        paymentDate: new Date,
        disabled: false,
        venueid: this.VenueID,
        refunds: null,
        balance: this.PayableTotal,
        paymenttype: "voucher",
        currency: this.CurrencySymbol,
        tillname: null
      }

      let payments: Payment[] = [];

      payments.push(newPayment);

      this.Voucher.payments = payments;

      this.http.post<cVoucher>(bmxurl + "/Voucher", this.Voucher).subscribe(response => {
        this.httpResponse = response
          if(this.httpResponse.succeeded)
          {
            this.Voucher = this.httpResponse.data;

            this.messageService.add({severity:'success', summary:'Saved', detail:'Voucher created successfully'});

            if(this.Voucher.recipientsemailsaddress == "")
            {
              this.Voucher.recipientsemailsaddress = this.Voucher.emailaddress;
              this.Voucher.recipientsname = this.Voucher.customername;
            }

            this.VoucherComplete = true;
            
          }
          }, error => {
            this.messageService.add({severity:'error', summary:'Error', detail:error.messages});
        })

    }
  }

  selectValue(value){
    switch(value){  
      case 5: {
        this.toggle5 = true;
        this.toggle10 = false;
        this.toggle20 = false;
        this.toggle25 = false;
        this.toggle50 = false;
        this.toggle100 = false;
        this.Voucher.customamount = false;
        this.Voucher.initialvalue = 5;
        break;
      }
      case 10: {
        this.toggle5 = false;
        this.toggle10 = true;
        this.toggle20 = false;
        this.toggle25 = false;
        this.toggle50 = false;
        this.toggle100 = false;
        this.Voucher.customamount = false;
        this.Voucher.initialvalue = 10;
        break;
      }
      case 20: {
        this.toggle5 = false;
        this.toggle10 = false;
        this.toggle20 = true;
        this.toggle25 = false;
        this.toggle50 = false;
        this.toggle100 = false;
        this.Voucher.customamount = false;
        this.Voucher.initialvalue = 20;
        break;
      }
      case 25: {
        this.toggle5 = false;
        this.toggle10 = false;
        this.toggle20 = false;
        this.toggle25 = true;
        this.toggle50 = false;
        this.toggle100 = false;
        this.Voucher.customamount = false;
        this.Voucher.initialvalue = 25;
        break;
      }
      case 50: {
        this.toggle5 = false;
        this.toggle10 = false;
        this.toggle20 = false;
        this.toggle25 = false;
        this.toggle50 = true;
        this.toggle100 = false;
        this.Voucher.customamount = false;
        this.Voucher.initialvalue = 50;
        break;
      }
      case 100: {
        this.toggle5 = false;
        this.toggle10 = false;
        this.toggle20 = false;
        this.toggle25 = false;
        this.toggle50 = false;
        this.toggle100 = true;
        this.Voucher.customamount = false;
        this.Voucher.initialvalue = 100;
        break;
      }
    }
  }

  setValue(){
    this.Voucher.initialvalue = this.customAmountValue;
  }
  
  customAmountToggle(){
    this.toggle5 = false;
    this.toggle10 = false;
    this.toggle20 = false;
    this.toggle25 = false;
    this.toggle50 = false;
    this.toggle100 = false;
  }

  DoValidCheck(){
    let AllValid = true;

    if(this.Voucher.customername == "")
    {
      AllValid = false;
      this.NameValid = false;
    }
    else
    {
      this.NameValid = true;
    }

    if(this.Voucher.emailaddress == "")
    {
      AllValid = false;
      this.EmailValid = false;
    }
    else
    {
      this.EmailValid = true;
    }

    if (this.Voucher.emailaddress != "") {
      if (!this.validateEmail(this.Voucher.emailaddress)) {
        AllValid = false;
        this.EmailFormatValid = false;
      }
      else {
        this.EmailFormatValid = true;
      }
    }

    if (this.Voucher.initialvalue <= 0) {
      AllValid = false;
      this.ValueValid = false;
    }
    else {
      this.ValueValid = true;
    }

    if(this.Voucher.alternativerecipient)
    {
      if(this.Voucher.recipientsname == "")
      {
        AllValid = false;
        this.RecipientNameValid = false;
      }
      else
      {
        this.RecipientNameValid = true;
      }
  
      if(this.Voucher.recipientsemailsaddress == "")
      {
        AllValid = false;
        this.RecipientEmailValid = false;
      }
      else
      {
        this.RecipientEmailValid = true;
      }

      if (this.Voucher.recipientsemailsaddress != "") {
        if (!this.validateEmail(this.Voucher.recipientsemailsaddress)) {
          AllValid = false;
          this.RecipientEmailValid = false;
        }
        else {
          this.RecipientEmailValid = true;
        }
      }

      if(this.Voucher.message == "")
      {
        AllValid = false;
        this.messageValid = false;
      }
      else
      {
        this.messageValid = true;
      }
    }

    return AllValid;
  }

  deferPayment(){
    this.showDeferReason = true;
  }

  get PayableTotal(): number {
    return this.Voucher.total > 0 ? this.Voucher.total : this.Voucher.initialvalue;
  }

  createVoucher(){
    if(this.Voucher.customamount)
    {
      this.Voucher.initialvalue = this.customAmountValue;
    }

    this.Voucher.currency = this.CurrencySymbol;

    if (!this.DoValidCheck())
      return;

    this.busyService.busy();

    this.http.post<any>(bmxurl + "CreatePublicVoucher", this.Voucher).subscribe(response => {
      this.busyService.idle();

      let createdVoucher = response?.data ?? response;

      if (response?.succeeded === false || createdVoucher?.voucherid == null) {
        this.messageService.add({severity:'error', summary:'Error', detail: response?.messages?.[0] ?? 'Could not create voucher.'});
        return;
      }

      this.Voucher = createdVoucher;
      this.VoucherCreated = true;
    }, error => {
      this.busyService.idle();
      this.messageService.add({severity:'error', summary:'Error', detail: 'Could not create voucher.'});
    })
  }

  displayDiscount(){
    this.showDiscount = !this.showDiscount;
  }

  doneDiscount(){
    let dv: cVoucherDiscountvalidate = {
      voucher: this.Voucher,
      discountcode: this.discountCode.trim()
    }

    this.busyService.busy();

    this.http.post<any>(bmxurl + "/DiscountValidateVoucher", dv).subscribe(response => {
      this.httpResponse = response;
      this.busyService.idle();

      if (this.httpResponse.succeeded == true) {
        this.messageService.add({ severity: 'success', summary: 'Discount Added', detail: 'Your discount has been added' });

        this.showDiscount = false;
        this.discountCode = "";

        this.Voucher = this.httpResponse.data;
      }
      else
      {
        this.messageService.add({ severity: 'error', summary: 'Not Added', detail: this.httpResponse.messages[0] });
      }
    }, error => {
      this.busyService.idle();
      this.messageService.add({ severity: 'error', summary: 'Not Added', detail: 'Error applying discount, please try again.' });
    })
  }

  doReferralNote(){

    this.showDeferReason = false;

    this.Voucher.payments = null;
    this.Voucher.deferredpayment = true;

    this.Voucher.defernotes = this.deferNotes;

    this.http.post<any>(bmxurl + "/VoucherDeferPayment", this.Voucher).subscribe(response => {
      this.httpResponse = response

      this.Voucher = this.httpResponse.data;

      this.messageService.add({severity:'success', summary:'Saved', detail:'Voucher created successfully'});

      if(this.Voucher.recipientsemailsaddress == "")
      {
        this.Voucher.recipientsemailsaddress = this.Voucher.emailaddress;
        this.Voucher.recipientsname = this.Voucher.customername;
      }

      this.VoucherComplete = true;

    }, error => {
    })

  }

  donePayment(id, name) {
    const generalTerminalName = localStorage.getItem(`GeneralTerminalName_${this.VenueID}`) ?? '';
    const isCardPayment = (name as string).toLowerCase().includes('card');

    if (isCardPayment && generalTerminalName) {
      this.paymentButtonLocked = true;
      this.pendingPaymentId = id;
      this.pendingPaymentName = name;

      const terminalPayload = {
        venueid: this.VenueID,
        connectedAccountId: localStorage.getItem('RyftSubAccountID') ?? '',
        amount: Math.round(this.PayableTotal * 100),
        currency: this.CurrencySymbol.toLowerCase(),
        terminalId: generalTerminalName,
        method: 'VOUCHER',
        identifier: this.Voucher.voucherid ?? ''
      };

      this.initiateVoucherTerminalPayment(terminalPayload);

      return;
    }

    this.Voucher.disabled = false;
    this.updateData(id, name);
  }

  connectTerminalHubVoucher(paymentIntentId: string): void {
    this.awaitingTerminalPayment = true;
    this.terminalPaymentResolved = false;

    this.terminalPollingIntervalId = setInterval(() => {
      this.ngZone.run(() => this.pollVoucherForPayment());
    }, 10000);

    this.auth.getAccessTokenSilently().subscribe({
      next: (token) => {
        const hub = new HubConnectionBuilder()
          .withUrl(environment.servicestarget + '/venue/' + this.VenueID, {
            accessTokenFactory: () => token
          })
          .build();

        this.terminalHubConnection = hub;

        hub.on(paymentIntentId, (message: string) => {
          this.ngZone.run(() => {
            if (this.terminalPaymentResolved) return;
            this.terminalPaymentResolved = true;
            this.stopTerminalPolling();
            hub.stop();
            this.terminalHubConnection = null;
            this.awaitingTerminalPayment = false;

            if (message === 'succeeded') {
              this.messageService.add({ severity: 'success', summary: 'Payment Succeeded', detail: 'Card payment completed successfully.' });
              this.completeVoucherAfterPayment();
            } else {
              this.paymentFailedMessage = message;
              this.showPaymentFailedDialog = true;
              this.paymentButtonLocked = false;
            }
          });
        });

        hub.start().catch(() => {
          this.terminalHubConnection = null;
        });
      },
      error: () => { /* polling continues */ }
    });
  }

  private pollVoucherForPayment(): void {
    if (this.terminalPaymentResolved) {
      this.stopTerminalPolling();
      return;
    }

    this.http.get<any>(bmxurl + 'Voucher/' + this.VenueID + '/' + this.Voucher.voucherid).subscribe(response => {
      if (this.terminalPaymentResolved) return;

      if (response.succeeded && response.data.payments?.length > 0) {
        this.terminalPaymentResolved = true;
        this.stopTerminalPolling();
        if (this.terminalHubConnection) {
          this.terminalHubConnection.stop();
          this.terminalHubConnection = null;
        }
        this.awaitingTerminalPayment = false;
        this.Voucher = response.data;
        this.messageService.add({ severity: 'success', summary: 'Payment Received', detail: 'Payment confirmed via terminal.' });
        this.completeVoucherAfterPayment();
      }
    });
  }

  private completeVoucherAfterPayment(): void {
    this.http.get<any>(bmxurl + 'Voucher/' + this.VenueID + '/' + this.Voucher.voucherid).subscribe(response => {
      if (response.succeeded) {
        this.Voucher = response.data;
      }
      if (this.Voucher.recipientsemailsaddress == "") {
        this.Voucher.recipientsemailsaddress = this.Voucher.emailaddress;
        this.Voucher.recipientsname = this.Voucher.customername;
      }
      this.VoucherComplete = true;
      this.paymentButtonLocked = false;
    }, () => {
      if (this.Voucher.recipientsemailsaddress == "") {
        this.Voucher.recipientsemailsaddress = this.Voucher.emailaddress;
        this.Voucher.recipientsname = this.Voucher.customername;
      }
      this.VoucherComplete = true;
      this.paymentButtonLocked = false;
    });
  }

  private stopTerminalPolling(): void {
    if (this.terminalPollingIntervalId !== null) {
      clearInterval(this.terminalPollingIntervalId);
      this.terminalPollingIntervalId = null;
    }
  }

  private initiateVoucherTerminalPayment(terminalPayload: any): void {
    this.http.post<any>(bmxurl + 'StripeTerminalPaymentInit', terminalPayload).subscribe(response => {
      this.httpResponse = response;
      if (this.httpResponse.succeeded) {
        const paymentIntentId: string = this.httpResponse.data?.paymentIntentId ?? this.httpResponse.data?.id ?? '';
        this.connectTerminalHubVoucher(paymentIntentId);
      } else {
        const detail = this.httpResponse.messages?.[0] ?? 'Unknown error';
        if (detail.toLowerCase().includes('payment_intent in progress')) {
          this.pendingTerminalPayload = terminalPayload;
          this.pendingTerminalRetry = () => this.initiateVoucherTerminalPayment(terminalPayload);
          this.showTerminalBusyDialog = true;
        } else {
          this.messageService.add({ severity: 'error', summary: 'Terminal payment failed', detail });
          this.paymentButtonLocked = false;
        }
      }
    }, () => {
      this.messageService.add({ severity: 'error', summary: 'Terminal payment failed', detail: 'Could not initiate terminal payment.' });
      this.paymentButtonLocked = false;
    });
  }

  waitForTerminal(): void {
    this.showTerminalBusyDialog = false;
  }

  clearTerminalAndRetryPayment(): void {
    const terminalId = this.pendingTerminalPayload?.terminalId ?? '';
    this.showTerminalBusyDialog = false;
    this.http.get<any>(bmxurl + 'StripeTerminalCancel/' + this.VenueID + '/' + terminalId).subscribe({
      complete: () => {
        this.pendingTerminalRetry?.();
      }
    });
  }

  cancelTerminalPayment(): void {
    this.terminalPaymentResolved = true;
    this.stopTerminalPolling();

    if (this.terminalHubConnection) {
      this.terminalHubConnection.stop();
      this.terminalHubConnection = null;
    }

    const terminalId = localStorage.getItem(`GeneralTerminalName_${this.VenueID}`) ?? '';
    this.http.get<any>(bmxurl + 'StripeTerminalCancel/' + this.VenueID + '/' + terminalId).subscribe({
      complete: () => {
        this.awaitingTerminalPayment = false;
        this.paymentButtonLocked = false;
      }
    });
  }

  validateEmail(email){
    var re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/; 
    return re.test(email); 
  }

}
